// @ts-nocheck
import React from 'react';
import { NavLink } from 'react-router-dom';

function SKUNameCell({ name, id, editable }) {
  return (
    <div className="grid-sku-name">
      <NavLink to={`/sku/${id}`}>{name}</NavLink>
    </div>
  );
}

export default SKUNameCell;
